import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorCircle } from '../../assets';
import { ModalContext } from '../../contexts/ModalContext';

interface IResponseModalProps {
  title: string;
  message: string;
}
export function SuccessModal(props: IResponseModalProps) {
  const { t } = useTranslation();
  const { title, message } = props;
  const { handleModal } = useContext(ModalContext);
  return (
    <div className="w-[328px] h-[162px] rounded-[10px] bg-N10 flex flex-col items-center justify-between p-4">
      <p className="text-lg font-bold text-N1 ">{title}</p>
      <p className="text-N1 text-[15px] ">{message}</p>
      <button className="w-full py-3 text-base rounded-lg text-N9 bg-N5" onClick={() => handleModal()}>
        {t('successModal.confirm')}
      </button>
    </div>
  );
}

export function FailModal(props: IResponseModalProps) {
  const { t } = useTranslation();
  const { title, message } = props;
  const { handleModal } = useContext(ModalContext);
  return (
    <div className="w-[328px] h-[218px] rounded-[10px] bg-N10 flex flex-col items-center justify-between p-4">
      <ErrorCircle />
      <p className="text-lg font-bold text-N1 ">{title}</p>
      <p className="text-N1 text-[15px] ">{message}</p>
      <button className="w-full py-3 text-base rounded-lg text-N9 bg-N5" onClick={() => handleModal()}>
        {t('successModal.confirm')}
      </button>
    </div>
  );
}

export function CustomModal({
  title,
  info,
  content,
  noText,
  confirmText,
  onClickNoFunction,
  onClickConfirmFunction,
  titleAlign,
  infoAlign,
  contentAlign,
}: {
  title?: string | undefined;
  info?: string | undefined;
  content?: string | undefined;
  noText?: string | undefined;
  confirmText?: string | undefined;
  onClickNoFunction?: Function | undefined;
  onClickConfirmFunction?: Function | undefined;
  titleAlign?: string | undefined;
  infoAlign?: string | undefined;
  contentAlign?: string | undefined;
}) {
  titleAlign = `text-lg font-bold text-N1 ${titleAlign}`;
  infoAlign = `text-[15px] text-N1 ${infoAlign}`;
  contentAlign = `text-slate-400 ${contentAlign}`;

  return (
    <div className="flex flex-col p-4 bg-N10 w-[328px] max-h gap-2">
      <p className={titleAlign}>{title}</p>
      <p className={infoAlign}>{info}</p>
      <div className={contentAlign}>
        {content ? content.split('\n').map((line, index) => <p key={index}>{line}</p>) : ''}
      </div>
      <footer className="flex w-full gap-2 mt-4">
        {noText && onClickNoFunction && (
          <button
            onClick={() => onClickNoFunction()}
            className="flex-1 w-full py-3 text-base rounded-lg text-N3 bg-N5 border border-N5 bg-transparent"
          >
            {noText}
          </button>
        )}
        {confirmText && onClickConfirmFunction && (
          <button
            onClick={() => onClickConfirmFunction()}
            className="flex-1 w-full py-3 text-base rounded-lg text-N9 bg-N5"
          >
            {confirmText}
          </button>
        )}
      </footer>
    </div>
  );
}
